module.exports = __webpack_public_path__ + "static/img/logo_login.37cd8d27.png";